import { Card, CardActionArea, CardContent, Grid, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import { FinanceType } from '../../services/dtos/finances.dto';
import { RelationType } from '../../services/dtos/relation.dto';

/**
 * Box qui s'affichera si le tableau ne contient aucune information
 * @param props
 * @constructor
 */
export default function CustomCard(
    props: Readonly<{
        little: boolean;
        text: string;
        icon: ReactElement;
        type: FinanceType | RelationType;
        handlerSetType: (newType: FinanceType | RelationType | undefined, text: string) => void;
        isSelected?: boolean;
        className?: string;
    }>
) {
    /**
     * Gestion du clic sur la card, pour changer le numéro de la page finance
     */
    const handlerClickOnCard = async () => {
        props.handlerSetType(props.type, props.text);
    };

    // retourne la box avec titre et message personnalisé
    return (
        <Card
            className={[props.className, props.isSelected ? 'customCard--selected' : undefined]
                .filter(Boolean)
                .join(' ')}
            onClick={handlerClickOnCard}
            sx={{
                borderRadius: '20px',
                padding: '0',
                ...(props.little ? { width: '125px' } : { width: '250px' }),
                ...(props.isSelected && { opacity: '0.55' }),
            }}
        >
            <CardActionArea>
                <CardContent sx={{ padding: '0' }}>
                    <Grid container className={'tab-content'} rowSpacing={1}>
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            {props.icon}
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sx={{
                                backgroundColor: '#3766A5',
                                height: '50px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Typography
                                sx={
                                    props.little
                                        ? { color: '#fff', textAlign: 'center', fontSize: '12px' }
                                        : { color: '#fff', textAlign: 'center', fontSize: 'inherit' }
                                }
                                variant="body1"
                            >
                                {props.text}
                            </Typography>
                        </Grid>
                    </Grid>
                </CardContent>
            </CardActionArea>
        </Card>
    );
}
